module.exports = __webpack_public_path__ + "static/media/close-modal.647acade.svg";